import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class IFrameHtml extends VisualSuperHtml {
  handlers = this.extendParentHandlers({
    url: this.setUrl,
    width: this.setWidth,
    height: this.setHeight,
  });

  setProps(eNode) {
    eNode.element = create(eNode, "iframe");

    eNode.element.style.pointerEvents = "auto";
    eNode.element.setAttribute("frameborder", 0);
    eNode.element.setAttribute("allowfullscreen", "");
    eNode.element.setAttribute("scrolling", eNode.props.scrollType);

    // TODO: permissions should be configurable
    eNode.element.setAttribute("allow", "clipboard-write");

    eNode.element.style.scrollTop = "60px";

    super.setProps(eNode);
    this.setUrl(eNode);
  }

  setUrl(eNode) {
    eNode.element.setAttribute("src", eNode.props.url);
  }

  setWidth(eNode) {
    eNode.element.setAttribute("width", eNode.props.width);
  }

  setHeight(eNode) {
    eNode.element.setAttribute("height", eNode.props.height);
  }
}

const indexFrameHtml = new IFrameHtml("visual:iframe");
visualEntities.set("visual:iframe", indexFrameHtml);
export { IFrameHtml, indexFrameHtml as iFrameHtml };
